var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84572 7.93453L6.72119 12.3625C7.04904 12.7371 7.04904 13.3445 6.72119 13.7191C6.39335 14.0936 5.8618 14.0936 5.53395 13.7191L0.245886 7.67705C-0.081961 7.30246 -0.081961 6.69513 0.245887 6.32054C0.267566 6.29578 0.290134 6.27264 0.313477 6.25115C0.347135 6.21772 0.383146 6.1873 0.42119 6.16026L5.56687 0.280942C5.89472 -0.093647 6.42627 -0.0936478 6.75411 0.280942C7.08196 0.655531 7.08196 1.26286 6.75411 1.63745L2.92181 6.01614L2.15112 7.01412L2.84572 7.93453Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d2aa724ed27cc8e222f898cae387a7ea.svg";
export { ForwardRef as ReactComponent };